import { render, staticRenderFns } from "./SendRedirectStatusUpdateEmailModal.vue?vue&type=template&id=304588c0&scoped=true"
import script from "./SendRedirectStatusUpdateEmailModal.vue?vue&type=script&lang=js"
export * from "./SendRedirectStatusUpdateEmailModal.vue?vue&type=script&lang=js"
import style0 from "./SendRedirectStatusUpdateEmailModal.vue?vue&type=style&index=0&id=304588c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "304588c0",
  null
  
)

export default component.exports